<div class="report-container">

  <div class="report-header">
    <h2 class="report-title">Invoice Reconciliation Report</h2>
    <button mat-raised-button class="download-btn" (click)="downloadCsv()">
      <mat-icon>download</mat-icon> Download CSV
    </button>
  </div>

  <!-- Date range + text filters -->
  <div class="filter-container">

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Date From</mat-label>
      <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="dateFrom" (dateChange)="loadData()">
      <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Date To</mat-label>
      <input matInput [matDatepicker]="pickerTo" [(ngModel)]="dateTo" (dateChange)="loadData()">
      <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Subscription Name</mat-label>
      <input matInput [(ngModel)]="subscriptionNameSearch" placeholder="Filter..." (keyup)="applyFilters()">
      <button *ngIf="subscriptionNameSearch" matSuffix mat-icon-button (click)="subscriptionNameSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Invoice Number</mat-label>
      <input matInput [(ngModel)]="invoiceNumberSearch" placeholder="Filter..." (keyup)="applyFilters()">
      <button *ngIf="invoiceNumberSearch" matSuffix mat-icon-button (click)="invoiceNumberSearch = ''; applyFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button mat-button class="clear-btn"
            *ngIf="subscriptionNameSearch || invoiceNumberSearch"
            (click)="clearFilters()">Clear Filters</button>

    <span class="spacer"></span>

    <span class="results-count">{{ dataSource.data.length }} record(s) found</span>

    <mat-paginator #paginator
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[25, 50, 100, 200]"
                   (page)="pageChanged($event)"
                   showFirstLastButtons>
    </mat-paginator>

  </div>

  <!-- Table -->
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 report-table">

    <ng-container matColumnDef="invoiceCreatedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Date</th>
      <td mat-cell *matCellDef="let row">{{ formatDate(row.invoiceCreatedDate) }}</td>
    </ng-container>

    <ng-container matColumnDef="invoiceNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Number</th>
      <td mat-cell *matCellDef="let row">{{ row.invoiceNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="subscriptionName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Subscription Name</th>
      <td mat-cell *matCellDef="let row">{{ row.subscriptionName }}</td>
    </ng-container>

    <ng-container matColumnDef="subscriptionTier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Subscription Tier</th>
      <td mat-cell *matCellDef="let row">{{ row.subscriptionTier }}</td>
    </ng-container>

    <ng-container matColumnDef="notificationCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Notification Count</th>
      <td mat-cell *matCellDef="let row">{{ row.notificationCount }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">No records found for the selected criteria.</td>
    </tr>

  </table>

</div>
